export enum SdkActionTypes {
    SET_IS_DOWNLOADING_ACUANT_SDK = "SET_IS_DOWNLOADING_ACUANT_SDK",
    SET_DOWNLOADING_ACUANT_SDK_SUCCESS = "SET_DOWNLOADING_ACUANT_SDK_SUCCESS",
    SET_DOWNLOADING_ACUANT_SDK_FAILED = "SET_DOWNLOADING_ACUANT_SDK_FAILED",
}

type SetIsDownloadingAcuantSdkAction = {
    type: SdkActionTypes.SET_IS_DOWNLOADING_ACUANT_SDK
};

export const setIsDownloadingAcuantSdk = (): SetIsDownloadingAcuantSdkAction => ({
    type: SdkActionTypes.SET_IS_DOWNLOADING_ACUANT_SDK
});

type SetDownloadingAcuantSdkSuccessAction = {
    type: SdkActionTypes.SET_DOWNLOADING_ACUANT_SDK_SUCCESS
};

export const setDownloadingAcuantSdkSuccess = (): SetDownloadingAcuantSdkSuccessAction => ({
    type: SdkActionTypes.SET_DOWNLOADING_ACUANT_SDK_SUCCESS
});

type SetDownloadingAcuantSdkFailedAction = {
    type: SdkActionTypes.SET_DOWNLOADING_ACUANT_SDK_FAILED
};

export const setDownloadingAcuantSdkFailed = (): SetDownloadingAcuantSdkFailedAction => ({
    type: SdkActionTypes.SET_DOWNLOADING_ACUANT_SDK_FAILED
});


export type SdkActions =
    SetIsDownloadingAcuantSdkAction |
    SetDownloadingAcuantSdkSuccessAction |
    SetDownloadingAcuantSdkFailedAction